var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gg:facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.52211 23H12.7326V14.5684H16.5263L16.9432 10.3789H12.7326V8.26316C12.7326 7.98398 12.8435 7.71624 13.0409 7.51884C13.2383 7.32143 13.5061 7.21053 13.7853 7.21053H16.9432V3H13.7853C12.3894 3 11.0507 3.55451 10.0636 4.54154C9.07661 5.52858 8.52211 6.86728 8.52211 8.26316V10.3789H6.41684L6 14.5684H8.52211V23Z",
    fill: "#7C7C7C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGgFacebook);
export default __webpack_public_path__ + "static/media/gg_facebook.a7576c0b2bb70e77cea1e01e764801f5.svg";
export { ForwardRef as ReactComponent };